import { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class ProductImpression extends PureComponent {
  static propTypes = {
    product: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    collectionOrderDetails: PropTypes.object.isRequired,
  };

  static contextTypes = {
    recordProductImpression: PropTypes.func,
  };

  componentDidMount = () => {
    this.recordProductImpression();
  };

  componentDidUpdate = () => {
    this.recordProductImpression();
  };

  recordProductImpression() {
    const { product, section, collectionOrderDetails } = this.props;
    const uid = `${section.id}.${product.sku}`;
    this.context.recordProductImpression({ uid, section, product, collectionOrderDetails });
  }

  render = () => null;
}
